module.exports = __webpack_public_path__ + "static/media/RHD-logo.8098867c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/RHD-logo.svg
// module id = 1222
// module chunks = 0